import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {
    WfProcessStepActivityChooseNextStepComponent
} from "../component/protected-components/process-activity/wf-process-step-activity-choose-next-step/wf-process-step-activity-choose-next-step.component";
import {
    WfProcessStepActivityMainPanelComponent
} from "../component/protected-components/process-activity/wf-process-step-activity-main-panel/wf-process-step-activity-main-panel.component";
import {
    WfProcessStepActivityObjectComponent
} from "../component/protected-components/process-activity/wf-process-step-activity-object/wf-process-step-activity-object.component";
import {
    WfProcessStepActivitySearchComponent
} from "../component/protected-components/process-activity/wf-process-step-activity-search/wf-process-step-activity-search.component";
import {
    WfProcessStepActivitySubProcessObjectComponent
} from "../component/protected-components/process-activity/wf-process-step-activity-sub-process-object/wf-process-step-activity-sub-process-object.component";
import {
    WfProcessStepOptionalActivityObjectCreateComponent
} from "../component/protected-components/process-activity/wf-process-step-optional-activity-object-create/wf-process-step-optional-activity-object-create.component";
import {
    WfProcessStepActivitySideGenericComponent
} from "../component/protected-components/process-activity-side/wf-process-step-activity-side-generic/wf-process-step-activity-side-generic.component";
import {
    WfProcessStepActivitySidePanelComponent
} from "../component/protected-components/process-activity-side/wf-process-step-activity-side-panel/wf-process-step-activity-side-panel.component";
import {
    WfObjectProcessesComponent
} from "../component/protected-components/wf-object-processes/wf-object-processes.component";
import {WfProcessComponent} from "../component/protected-components/wf-process/wf-process.component";
import {
    WfProcessConfigOverviewComponent
} from "../component/protected-components/wf-process-config-overview/wf-process-config-overview.component";
import {
    WfProcessShowAllProcessedActivitiesComponent
} from "../component/protected-components/wf-process-show-all-processed-activities/wf-process-show-all-processed-activities.component";
import {WfProcessStartComponent} from "../component/protected-components/wf-process-start/wf-process-start.component";
import {Provider} from "@angular/core";
import {
    WfProcessHeaderComponent
} from "../component/protected-components/wf-process/components/wf-process-header.component";

const wfModuleEntry : TestModuleDefinition = {
    key: 'wf',
    label: 'WorkFlow (wf)',
    components: [
        {
            key: 'WfProcessStepActivityChooseNextStepComponent',
            component: WfProcessStepActivityChooseNextStepComponent,
            label: 'Workflow Step Activity Choose Next Step',
            type: 'Component',
            selector: 'mvs-wf-process-step-activity-choose-next-step'
        },
        {
            key: 'WfProcessStepActivityMainPanelComponent',
            component: WfProcessStepActivityMainPanelComponent,
            selector: 'mvs-wf-process-show-main-activities',
            label: 'Workflow Process Show Main',
            type: 'Component',
        },
        {
            key: 'WfProcessStepActivityObjectComponent',
            component: WfProcessStepActivityObjectComponent,
            selector: 'mvs-wf-process-step-activity-object',
            label: 'Workflow Process Step Activity Object Component',
            type: 'Component',
        },
        {
            key: 'WfProcessStepActivitySearchComponent',
            component: WfProcessStepActivitySearchComponent,
            selector: 'mvs-wf-process-step-activity-search',
            label: 'Workflow Process Step Activity Search Component',
            type: 'Component',
        },
        {
            key: 'WfProcessStepActivitySubProcessObjectComponent',
            component: WfProcessStepActivitySubProcessObjectComponent,
            selector: 'mvs-wf-process-step-activity-sub-process-object',
            label: 'Workflow Process Sub Process Object Component',
            type: 'Component',
        },
        {
            key: 'WfProcessStepOptionalActivityObjectCreateComponent',
            component: WfProcessStepOptionalActivityObjectCreateComponent,
            selector: 'mvs-wf-process-step-optional-activity-object-create',
            label: 'Workflow Process Step Optional Activity Object Component',
            type: 'Component',
        },
        {
            key: 'WfProcessStepActivitySideGenericComponent',
            component: WfProcessStepActivitySideGenericComponent,
            selector: 'mvs-wf-process-step-activity-side-generic',
            label: 'Workflow Side Generic Component',
            type: 'Component',
        },
        {
            key: 'WfProcessStepActivitySidePanelComponent',
            component: WfProcessStepActivitySidePanelComponent,
            selector: 'mvs-wf-process-show-step-activities',
            label: 'Workflow Side Panel Generic Component',
            type: 'Component',
        },
        {
            key: 'WfObjectProcessesComponent',
            component: WfObjectProcessesComponent,
            selector: 'wf-object-processes',
            label: 'Workflow Object Processes',
            type: 'Component',
        },
        {
            key: 'WfProcessComponent',
            component: WfProcessComponent,
            selector: 'mvs-wf-process',
            label: 'Workflow Process Component',
            type: 'ObjectBaseComponent',
        },
        {
            key: 'WfProcessConfigOverviewComponent',
            component: WfProcessConfigOverviewComponent,
            selector: 'wf-process-config-overview',
            label: 'Workflow Process Config Overview',
            type: 'ObjectBaseComponent',
        },
        {
            key: 'WfProcessShowAllProcessedActivitiesComponent',
            component: WfProcessShowAllProcessedActivitiesComponent,
            selector: 'mvs-wf-process-show-all-processed-activities',
            label: 'Workflow Process Show All Processed Activities',
            type: 'Component',
        },
        {
            key: 'WfProcessStartComponent',
            component: WfProcessStartComponent,
            selector: 'mvs-wf-process-start',
            label: 'Workflow Step Start',
            type: 'Component',
        },
        {
            key: 'WfProcessHeaderComponent',
            component: WfProcessHeaderComponent,
            selector: 'wf-process-header',
            label: 'Workflow Process Header',
            type: 'Component',
        }
    ]
}

export const WF_TEST_PROVIDERS: Provider[] = [
    {
        provide: TEST_MODULE_REGISTRY, useValue: wfModuleEntry, multi: true
    }
]